import type { DetailedHTMLProps, LabelHTMLAttributes } from 'react';
import { css, styled } from 'styled-components';

type FuuzeLabelProps = DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & {
  required?: boolean;
};

export function FuuzeLabel({ required, ...props }: FuuzeLabelProps) {
  return <LabelStyled {...props} $required={required} />;
}

const LabelStyled = styled.label<{ $required: FuuzeLabelProps['required'] }>`
  ${props =>
    props.$required &&
    css`
      &:after {
        content: ' *';
        color: ${props.theme.colors.red};
      }
    `}
`;
